import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Toast } from "react-bootstrap";
import { connect } from "react-redux";
import validate from "./../../../_services/formValidation";
import { _HttpServices } from "./../../../_services/_HttpServices";
import { IoIosClose, IoMdDoneAll,IoMdCalendar } from "react-icons/io";
import Loader from "./../../../components/Loader";
import { useHistory } from "react-router-dom";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Footer } from "../../../components/Footer";
const initialValues = {
  HolidayDate: '',
  HolidayDescription: "",
  Isactive : true,
  CreatedBy:'',
  CreatedOn:''
};
// let btnText = "Submit";
const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
const AddHoliday = ({ dispatch, login }) => {
  const history = useHistory();
  const [values, setValues] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setSubmitDisable] = useState(false);  
  const [holidayCreated, setHolidayCreated] = useState(false);  
  const [showToaster, setShowToaster] = useState(false);  
  
  const handleChange = (event) => {
    event.persist();
    const re = /^[a-zA-Z0-9 \b]+$/;
    if (event.target.value === "" || (re.test(event.target.value) && event.target.value.trim().length > 0)) {
      setValues((values) => ({
        ...values,
        HolidayDescription: event.target.value,
      }));
    }
  };

  const handleChangeDate = (date) => {
      setValues((values) => ({
        ...values,HolidayDate : date
      }))
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(values);
    setLoading(true);
    let loggedInUserData = JSON.parse(localStorage.getItem("userData"));
    values.CreatedBy = loggedInUserData.UserName;
    let date = new Date();
    values.CreatedBy =  date //moment(date).format('MM/DD/YYYY')
    // values.HolidayDate = moment(values.HolidayDate).format('MM/DD/YYYY')
  let holiday = {
    HolidayDate: moment(values.HolidayDate).format('MM/DD/YYYY'),
    HolidayDescription: values.HolidayDescription,
    Isactive : true,
    CreatedBy: loggedInUserData.UserName,
    CreatedOn: moment(date).format('MM/DD/YYYY'),
  }
    _HttpServices
        .postData("Api/Client/AddHolidays", holiday)
        .then((data) => {
        if (data.data || data.data === "") {
            setValues(initialValues);
            setShowToaster(true);
            setHolidayCreated(true);
            setLoading(false);
            setTimeout(() =>
              history.push("/holidays")
            ,500)            
        }
        })
        .catch((e) => {
        setLoading(false);
        });
    }
  useEffect(() => {
    
    setSubmitDisable(validateForm());
  }, [dispatch,values]);
  const validateForm = () => {
    if (values.HolidayDescription !== null && values.HolidayDescription.length > 0 &&
      values.HolidayDate !== null && values.HolidayDate !== '') {
      return false;
    } else {
      return true;
    }
  };
  const cancelHandler = () => {
        // localStorage.removeItem("editUserData");
        history.push("/holidays");
  };
  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Add Holiday</h2>
      </div>
      {/* Toaster */}
      <Toast
        onClose={() => setShowToaster(false)}
        show={showToaster}
        delay={1500}
        autohide
        className="custom-toaster"
      >
        {holidayCreated && <Toast.Body>Holiday Created Successfully</Toast.Body>}
      </Toast>
      <div className="card pt-2 pb-3">
        <div className="card-body">
          <Form
            noValidate
            onSubmit={(e) => handleSubmit(e)}
          >
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="HolidayDescription">
                    Holiday Description<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="HolidayDescription"
                    value={values.HolidayDescription}
                    onChange={(e) => handleChange(e)}
                    maxLength={50}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter Holiday Description.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                    <div className="date-picker ungroup-date-picker pos-rl task-startdate">
                        <IoMdCalendar className="icon date-icon" />
                        <Form.Label htmlFor="StartDate">Holiday Date<span className="required">*</span></Form.Label>
                        <DatePicker
                            selected={values.HolidayDate}
                            onChange={date => handleChangeDate(date)}
                            minDate={new Date()}
                            autoComplete="off"
                            // maxDate={addMonths(new Date(), 5)}
                            name="holidayDate"
                            required
                            className='form-control'
                            // className={startDateGreaterErr ? 'form-control is-invalid' : ' form-control'} isInvalid={startDateGreaterErr ? true : false}
                        />
                    </div>
                    {/* {holidayDateError ? <div className="err-feedback d-block">Please select start date.</div> : null} */}
                </Form.Group>
            </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={disableSubmit}
                  >
                    <IoMdDoneAll className="icon btn-icon" />
                    Submit
                  </Button>
                {/* )} */}
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                  onClick={cancelHandler}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
              {loading ? <Loader /> : null}
            </Row>
          </Form>
        </div>
      </div>
            
            <Footer />
    </section>
  );
};
// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});
// Connect Redux to React
export default connect(mapStateToProps)(AddHoliday);
